/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yes_Import_SettingsInputs */

const en_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, Import Settings`)
};

const fr_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, importer les paramètres`)
};

const de_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, Importeinstellungen`)
};

const it_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, importa impostazioni`)
};

const ru_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, импорт настроек.`)
};

const es_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, importar configuraciones`)
};

const zh_cn2_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，导入设置`)
};

const ja_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、設定をインポートします`)
};

const hi_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, सेटिंग्स आयात करें`)
};

const pt_pt2_yes_import_settings = /** @type {(inputs: Yes_Import_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, importar configurações`)
};

/**
* | output |
* | --- |
* | "Yes, Import Settings" |
*
* @param {Yes_Import_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const yes_import_settings = /** @type {((inputs?: Yes_Import_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yes_Import_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_yes_import_settings(inputs)
	if (locale === "de") return de_yes_import_settings(inputs)
	if (locale === "it") return it_yes_import_settings(inputs)
	if (locale === "ru") return ru_yes_import_settings(inputs)
	if (locale === "es") return es_yes_import_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_yes_import_settings(inputs)
	if (locale === "ja") return ja_yes_import_settings(inputs)
	if (locale === "hi") return hi_yes_import_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_yes_import_settings(inputs)
	return en_yes_import_settings(inputs)
});